import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { FetchStatus } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { ConnectedServiceData } from '@lyrahealth-inc/shared-app-logic/src/features/connectedService/types'

import {
  GET_CONNECTED_SERVICES_FULFILLED,
  GET_CONNECTED_SERVICES_PENDING,
  GET_CONNECTED_SERVICES_REJECTED,
} from './connectedServiceActions'

const initialState = fromJS({
  connectedServices: null,
  connectedServiceLoadingStatus: null,
})

export default createReducer(initialState, {
  [GET_CONNECTED_SERVICES_PENDING]: ($$state: Map<string, any>) => {
    return $$state.set('connectedServiceLoadingStatus', FetchStatus.PENDING)
  },
  [GET_CONNECTED_SERVICES_FULFILLED]: ($$state: Map<string, any>, action: { payload: ConnectedServiceData[] }) => {
    return $$state
      .set('connectedServices', fromJS(action.payload))
      .set('connectedServiceLoadingStatus', FetchStatus.SUCCESS)
  },
  [GET_CONNECTED_SERVICES_REJECTED]: ($$state: Map<string, any>) => {
    return $$state.set('connectedServiceLoadingStatus', FetchStatus.ERROR)
  },
})
